
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/parcelamento-bens-servicos",
      function () {
        return require("private-next-pages/parcelamento-bens-servicos.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/parcelamento-bens-servicos"])
      });
    }
  